import React from 'react';
import RecipeIngredients from "../../../RecipeIngredients/RecipeIngredients";
import "./RecipeListElement.css";

function RecipeListElement({ recipe, index, onClick, showIngredients = false}) {
       
    const handleClick = () => {
        onClick(index)
    }

    return (
        <li onClick={handleClick} key={index} className="recipe-list-element recipe-element hoverable-element" style={{ whiteSpace: 'pre-wrap', display: 'block' }} >
            <p>{recipe.Recipe_Name}:</p>
            <p>Time: {recipe.Recipe_Time}m                 Difficulty: {recipe.Recipe_Difficulty}/10</p>
            {showIngredients ? <RecipeIngredients Recipe_Ingredients={recipe.Recipe_Ingredients} ingredientsVisible={showIngredients}/> : null}
        </li>
    )
}

export default RecipeListElement;